import { useContext } from 'react'
import { Grid } from '@chakra-ui/react'
import { SnippetsContext } from './Snippets'
import { useColorMode } from 'uikit/ColorMode/ColorMode'

export const SnippetsHeading = ({ children, ...props }) => {
  const { columns, gap, itemWidth } = useContext(SnippetsContext)
  const { colorMode } = useColorMode()
  const themeBgContainer = colorMode === 'light' ? 'gray.50' : 'gray.700'
  const themeBorderWidth = colorMode === 'light' ? '1px' : 'none'
  return (
    <Grid
      fontSize="0.84rem"
      alignItems="center"
      pr="16px"
      pl="16px"
      gap={gap}
      minHeight="36px"
      gridTemplateColumns={columns}
      borderColor="gray.200"
      borderBottomWidth={themeBorderWidth}
      backgroundColor={themeBgContainer}
      fontWeight="semibold"
      minWidth={itemWidth}
      position="sticky"
      top="0"
      zIndex={3}
      lineHeight="16px"
      {...props}
    >
      {children}
    </Grid>
  )
}
